import React, { ReactElement, ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { SizesType } from 'types/Sizes';
import { getLinariaClassName } from '../../../utils/getLinariaClassName';
import { Text } from '../../designSystem/Text';
export type TagVariant = (typeof TAG_VARIANTS)[number];
export type TagSize = Extract<SizesType, 'sm' | 'md'>;
interface Props {
  /** Content to be displayed in the Tag */
  children?: ReactNode;
  /** Identify the element for selection in integration tests, FullStory, etc. */
  dataId?: string;
  /** The button click handler */
  onClick?: () => void;
  /** The size of the tag */
  size?: TagSize;
  /** An Icon to display on the left side of the input. Inverted direction for RTL  */
  iconStart?: ReactElement;
  /** An Icon to display on the right side of the input. Inverted direction for RTL */
  iconEnd?: ReactElement;
  /** The variation of styling the component will have */
  variant?: TagVariant;
  /** Pass through classname to allow styles overrides */
  className?: string;
  /** Extra element to be displayed on the right side (left if RTL) */
  annotation?: ReactNode;
  /** Style prop is used by Linaria to pass CSS variables in cases when we need to style custom components in this way: `const StyledTag = styled(Tag)` */
  style?: React.CSSProperties;
}
export const AnnotationLabelStyles = "a1qx4m7r";
const TextWrapper = /*#__PURE__*/styled('span')({
  name: "TextWrapper",
  class: "thqglo7",
  propsAsIs: false
});
export const BasicTagWrapper = /*#__PURE__*/styled('span')({
  name: "BasicTagWrapper",
  class: "b1ypyijc",
  propsAsIs: false
});
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w37013",
  propsAsIs: false
});
export const BasicTag = ({
  children,
  dataId,
  onClick,
  size = 'sm',
  iconStart,
  iconEnd,
  variant = 'info',
  className,
  style
}: Props) => <BasicTagWrapper data-id={dataId} onClick={onClick} className={cx(`${getLinariaClassName(BasicTagWrapper)}--size-${size}`, `${getLinariaClassName(BasicTagWrapper)}--variant-${variant}`, className)} style={style}>
    {iconStart}

    {Boolean(children) && <TextWrapper>{children}</TextWrapper>}

    {iconEnd}
  </BasicTagWrapper>;
export const Tag = ({
  annotation,
  children,
  className,
  dataId,
  iconEnd,
  iconStart,
  onClick,
  size = 'sm',
  variant = 'info',
  style
}: Props) => {
  const hasAnnotation = Boolean(annotation);
  if (!hasAnnotation) {
    return <BasicTag className={className} dataId={dataId} iconEnd={iconEnd} iconStart={iconStart} onClick={onClick} size={size} variant={variant} style={style}>
        {children}
      </BasicTag>;
  }
  return <Wrapper className={cx(`${getLinariaClassName(Wrapper)}--variant-${variant}`)}>
      <BasicTag className={className} dataId={dataId} iconEnd={iconEnd} iconStart={iconStart} onClick={onClick} size={size} variant={variant} style={style}>
        {children}
      </BasicTag>
      <div className={cx(AnnotationLabelStyles, `${AnnotationLabelStyles}--variant-${variant}`, hasAnnotation && 'hasAnnotation')}>
        <Text variant={size === 'sm' ? 'labelXS' : 'labelS'}>{annotation}</Text>
      </div>
    </Wrapper>;
};

require("./Tag.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Tag.tsx");